import { CallWithConfig } from './service-communicator'
import { ServiceInfo } from './dto/serviceinfo.dto'
import { TicketInfo } from './dto/ticketinfo.dto'
import { OfficeInfo } from './dto/officeinfo.dto'

export class Gala {
  constructor(baseurl)
  { 
    this.configs = {
      getAllOffices: () => {
        return {
          method: 'get',
          url: '/branches',
          baseURL: baseurl,
          headers: {
            Accept: 'application/json'
          },
          responseType: 'json'
        }
      },
      getAvailableQueues: (branchID) => {
        return {
          method: 'get',
          url: '/supervision/table1?idBranches=' + branchID,
          baseURL: baseurl,
          headers: {
            Accept: 'application/json'
          },
          responseType: 'json'
        }
      },
      getTicketInfo: ticketID => {
        return {
          method: 'get',
          url: '/tickets/details/' + ticketID,
          baseURL: baseurl,
          headers: {
            Accept: 'application/json'
          },
          responseType: 'json'
        }
      },
      cancelTicket: (ticketID) => {
        return {
          method: 'post',
          url: 'supervision/cancelTicket',
          baseURL: baseurl,
          data: JSON.stringify({
            idTicket: ticketID
          }),
          headers: {
            Accept: 'application/json',
            'content-type': 'application/json'
          },
          responseType: 'json'
        }  
      },
      takeTicket: (branchID, segmentID, serviceID, tickettextFull) => {
        var addPhone='&notes=eTicket';
        var tickettext = tickettextFull.split(',');
        tickettext.push("");
        if(tickettext[0]!=""){
          addPhone = addPhone + "&customerName="+tickettext[0];
        }
        if(tickettext[1] != ''){
          tickettext[1] = tickettext[1].replace('+','%2B')
          addPhone += `&sms=N&phoneNumber=${tickettext[1]}`;
        }
        return {
          method: 'post',
          url: '/branches/' + branchID + '/ticketsByShort?idShortSegment=' + segmentID + '&idShortService=' + serviceID + addPhone,
          baseURL: baseurl,
          headers: {
            Accept: 'application/json'
          },
          responseType: 'json'
        }
      },
      setReminder: ticketID => {
        throw 'set reminder function not implemented'
      }
    }
  }
  
  async getAllOffices() {
    const result = await CallWithConfig(this.configs.getAllOffices());
    var listOfAllOffices = [];
    try 
    {
      listOfAllOffices = result.map(x => new OfficeInfo(x.name, x.idBranches, x.address, x.city, x.address.split('-')[1] ? x.address.split('-')[1].trim() : "", x.latitude, x.longitude, null, x.telephone))
    }
    catch
    {
      throw "We caught this bug before it could do any harm!"
    }
    return listOfAllOffices;
  }

  async getAvailableQueuesForSelectedOffice(branchID) {
    const queuesResult = await CallWithConfig(this.configs.getAvailableQueues(branchID));
    var listOfAllServiceTypes = null;
    try
    {
      // TODO: Vi måste hämta en del info från config, t.ex. namn, service och segment.
      listOfAllServiceTypes = queuesResult.map((x, i) => {
        return new ServiceInfo(x.queueName, x.waiting, x.maxWaiting, true, x.idQueues, null, null)
      });
    }
    catch
    {
      throw "This isn't the queue we're looking for"
    }
    return listOfAllServiceTypes;
  }

  async getIndividualTicketInfo(ticketID) {
    const ticketResult = await CallWithConfig(this.configs.getTicketInfo(ticketID));
    let ticket;
    if ( ticketResult )
      ticket = new TicketInfo(ticketResult.ticketsFirstWaiting, ticketResult.id, ticketResult.ticketWorkstationAttending, ticketResult.ticketNumber, ticketResult.created, (ticketResult.ticketStateName === 'assisted' || ticketResult.ended));
    return ticket;
  }

  async cancelTicket(ticketID) {
    var result = await CallWithConfig(this.configs.cancelTicket(ticketID));
    return result;
  }

  // TODO: Extenda denna med serviceID och segmentID direkt istället för att använda den här konstiga lookupen
  async grabATicket(queuedata, branchID, tickettext) {
    var result;
    try
    {
      result = await CallWithConfig(this.configs.takeTicket(branchID, queuedata.segmentID, queuedata.serviceID, tickettext));
    }
    catch
    {
      throw "Something, somewhere, went very wrong."
    }
    if (result)
      return result.id;
    return null;
  }

  async setReminder(ticketID) {
    const result = await CallWithConfig(this.configs.setReminder(ticketID));
  }  
}


